import axios from "axios";
import {toast} from "react-toastify";
import React, {useContext, useState} from "react";
import {AuthUserContext} from "../context/AuthUser";

const ProxySettings = () => {
    const [loading, setLoading] = useState(false);
    const [isProxyActive, setIsProxyActive] = useState(localStorage.getItem('use_proxy') === "1");
    const authUser = useContext(AuthUserContext);
    const axiosConfig = {
        headers: {
            Authorization: authUser.authUser !== null ? "Bearer " + authUser.authUser.api_key : ''
        }
    };

    const activateProxy = () => {
        setLoading(true);
        axios.get('/api/proxy/activate', {
            ...axiosConfig
        }).then(() => {
            localStorage.setItem('use_proxy', "1");
            setIsProxyActive(true);
            toast.success("Proxy activated!");
        }).catch(() => {
            toast.error("Failed to activate proxy.");
        }).finally(() => {
            setLoading(false);
        });
    };

    const disableProxy = () => {
        axios.get('/api/proxy/disable', {
            ...axiosConfig
        }).then(() => {
            localStorage.removeItem('use_proxy');
            setIsProxyActive(false);
            toast.success("Proxy disabled!");
        }).catch(() => {
            toast.error("Failed to disable proxy.");
        });
    };

    return <div className="proxy-settings">
        <div className="content">
            <div>
                Proxy status: {isProxyActive ? <span className="text-success">Active</span> :
                <span className="text-danger">Inactive</span>}
            </div>
            <div>
                {isProxyActive ?
                    <button className="btn btn-custom ml-4" disabled={loading} onClick={disableProxy}>Disable
                        Proxy</button> :
                    <button className="btn btn-outline-custom ml-4" disabled={loading} onClick={activateProxy}>Activate
                        Proxy</button>
                }
            </div>
        </div>
    </div>;
}
export default ProxySettings;
